<div class="transport-column-editor">

  @if (!editMode) {
    <div class="readonly-layout">
      <div class="readonly-columns">
        @for (item of configuredColumns; track item) {
          <div class="column-box">{{ item | translate
            :[columnsByKey.get(item) == null ? 'shared.transport-column-editor.invalid-column'
          :columnsByKey.get(item).dictionaryKey, translationService.language]}}</div>
        }
      </div>
      <div>
        <sc-action-icon (click)="startEditing()" iconClass="fa-edit"></sc-action-icon>
      </div>
    </div>
  }

  @if (editMode) {
    <div class="editor-layout">
      <div class="editor-column">
        <div class="header-layout">
          <div class="column-header">
            <div class="header-label">
              <sc-dictionary-label dictionaryKey="shared.transport-column-editor.configured-columns"></sc-dictionary-label>
            </div>
          </div>
        </div>
      </div>
      <div class="editor-column">
        <div class="header-layout">
          <div class="column-header">
            <div class="header-label">
              <sc-dictionary-label dictionaryKey="shared.transport-column-editor.available-columns"></sc-dictionary-label>
            </div>
            <sc-action-icon (click)="endEditing()" iconClass="fa-times"></sc-action-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="editor-layout lists">
      <div class="editor-column">
        <div cdkDropList #availableList="cdkDropList" [cdkDropListData]="configuredColumns"
          [cdkDropListConnectedTo]="[configuredList]" class="list" (cdkDropListDropped)="drop($event)">
          @for (item of configuredColumns; track item) {
            <div class="list-item-box" cdkDrag>{{ item | translate
              :[columnsByKey.get(item) == null ? 'shared.transport-column-editor.invalid-column'
            :columnsByKey.get(item).dictionaryKey, translationService.language]}}</div>
          }
        </div>
      </div>
      <div class="editor-column">
        <div cdkDropList #configuredList="cdkDropList" [cdkDropListData]="availableColumns" cdkDropListSortingDisabled
          [cdkDropListConnectedTo]="[availableList]" class="list" (cdkDropListDropped)="dropToAvailableList($event)">
          @for (item of availableColumns; track item) {
            <div class="list-item-box" cdkDrag>{{ item | translate
              :[columnsByKey.get(item) == null ? 'shared.transport-column-editor.invalid-column'
            :columnsByKey.get(item).dictionaryKey, translationService.language]}}</div>
          }
        </div>
      </div>
    </div>
  }
</div>
